const MERGE_FIELD_TOKEN = /\{[^{}]*\}/
const MERGE_FIELD_TOKEN_GLOBAL = /\{[^{}]*\}/g

export const hasMergeFieldToken = (text: string) => MERGE_FIELD_TOKEN.test(text)

export const stripMergeFieldTokens = (text: string) => text.replace(MERGE_FIELD_TOKEN_GLOBAL, '')

export type IMergeFieldUrlParts = {
  shortenable: string
  params: string[]
}

const tokenKey = (token: string) => token.replace(/[{}]/g, '').split('|')[0].trim()

const toParams = (text: string) =>
  (text.match(MERGE_FIELD_TOKEN_GLOBAL) ?? []).map((token) => `${tokenKey(token)}=${token}`)

export const splitAtMergeField = (url: string): IMergeFieldUrlParts => {
  const tokenAt = url.search(MERGE_FIELD_TOKEN)

  if (tokenAt === -1) return { shortenable: url, params: [] }

  const queryAt = url.indexOf('?')
  const inQuery = queryAt !== -1 && queryAt < tokenAt
  const splitAt = inQuery
    ? Math.max(url.lastIndexOf('?', tokenAt), url.lastIndexOf('&', tokenAt))
    : tokenAt

  const remainder = url.slice(inQuery ? splitAt + 1 : splitAt)
  const params = inQuery
    ? remainder
        .split('&')
        .filter(Boolean)
        .flatMap((segment) => (segment.includes('=') ? [segment] : toParams(segment)))
    : toParams(remainder)

  return { shortenable: url.slice(0, splitAt), params }
}

export const appendMergeFieldParams = (shortUrl: string, params: string[]) => {
  if (!params.length) return shortUrl

  const separator = shortUrl.includes('?') ? '&' : '?'

  return shortUrl + separator + params.join('&')
}

export const encodeMergeFieldBraces = (url: string) =>
  url.replace(/\{/g, '%7B').replace(/\}/g, '%7D')
